import { Box, Button, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useFormikContext } from 'formik';
import { EstimatesRow } from '../../components/EstimatesRow';
import { Estimate, RaptorJobFormValues } from '../../../../RaptorJobValidationSchema';
import tid from '@/common/infrastructure/config/tid';

export function EstimatesSection() {
  const { values, setFieldValue } = useFormikContext<RaptorJobFormValues>();

  const addEstimate = () => {
    const newEstimate: Estimate = {
      id: `estimate-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      metricType: '',
      quantity: null,
      unit: ''
    };
    const currentEstimates = values.estimates;
    setFieldValue('estimates', [...currentEstimates, newEstimate]);
  };

  return (
    <>
      <Typography variant="h6" component="div" sx={{ fontSize: '1rem', mb: '12px', fontWeight: 600 }}>
        Estimates
      </Typography>

      {values.estimates && values.estimates.length > 0 && (
        <Box>
          {values.estimates.map((estimate, index) => (
            <EstimatesRow key={estimate.id} index={index} />
          ))}
        </Box>
      )}

      <Button
        variant="text"
        startIcon={<AddCircleOutlineIcon />}
        onClick={addEstimate}
        sx={{ whiteSpace: 'nowrap' }}
        {...tid('jobs:create:add-estimate-button')}
      >
        ADD ESTIMATE(S)
      </Button>
    </>
  );
}
